export default __webpack_public_path__ + "static/crystal-d9ba5c6c60fb769c267c84b023a41e4d.webp";